module.exports = __webpack_public_path__ + "img/icon-folder.e95a3fb6.svg";